module.exports = __webpack_public_path__ + "img/de.60f0ff3b.svg";